// -----------------------------------------------------------
// TOP-LEVEL THIRD-PARTY DEPENDENCIES
// -----------------------------------------------------------

// Global cache
window.global = {};

// HighCharts
import Highcharts from "highcharts/highcharts";
import HighchartsMore from "highcharts/highcharts-more";
import SolidGauge from "highcharts/modules/solid-gauge";
HighchartsMore(Highcharts);
SolidGauge(Highcharts);
window.Highcharts = Highcharts;

// Moment.js
import moment from "moment";
window.moment = moment;

// XLSX
import * as XLSX from "xlsx";
window.XLSX = XLSX;

// -----------------------------------------------------------
// THIRD-PARTY DEPENDENCIES
// -----------------------------------------------------------

import "chosen-js";
import "clipboard";
import "croppie";
import "jquery-ujs";
// Must run after jQuery is global (jquery-ujs pulls it in) and before any SJR fires.
import "../shared/csp_nonce_eval.js";
import "pusher-js";
import "underscore";
import "velocity-animate";

// -----------------------------------------------------------
// TOP-LEVEL VENDORED DEPENDENCIES
// -----------------------------------------------------------

import "snapsvg-cjs";
import MCDatepicker from "mc-datepicker";
window.MCDatepicker = MCDatepicker;

// CKEDITOR 4
window.CKEDITOR_BASEPATH = "/ckeditor4/";
import '../ckeditor4/config'

// -----------------------------------------------------------
// VENDORED DEPENDENCIES
// -----------------------------------------------------------

import "../../../vendor/assets/javascripts/canvasAreaDraw";
import "../../../vendor/assets/javascripts/jquery.imagemapster";
import "../../../vendor/assets/javascripts/multiSelect";
import "../../../vendor/assets/javascripts/jquery.raty";
import "../../../vendor/assets/javascripts/jquery.leanModal";
import "../../../vendor/assets/javascripts/tag-it";
import "../../../vendor/assets/javascripts/wice_grid.coffee";

// -----------------------------------------------------------
// LOCAL DEPENDENCIES
// -----------------------------------------------------------

// CoffeeScript modules
import "../coffeescript/applications.coffee";
import "../coffeescript/augmented_reality_pages.coffee";
import "../coffeescript/applications.coffee";
import "../coffeescript/augmented_reality_pages.coffee";
import "../coffeescript/blueprints.coffee";
import "../coffeescript/chapters.coffee";
import "../coffeescript/checklists.coffee";
import "../coffeescript/courses.coffee";
import "../coffeescript/essay_pages.coffee";
import "../coffeescript/faqs.coffee";
import "../coffeescript/file_categories.coffee";
import "../coffeescript/functions.coffee";
import "../coffeescript/glossaries.coffee";
import "../coffeescript/glossary_import.coffee";
import "../coffeescript/image_pages.coffee";
import "../coffeescript/info_spots.coffee";
import "../coffeescript/manager_checklists.coffee";
import "../coffeescript/menu-items.coffee";
import "../coffeescript/page_drag_drop.coffee";
import "../coffeescript/pages.coffee";
import "../coffeescript/password_policy.coffee";
import "../coffeescript/people.coffee";
import "../coffeescript/people_import.coffee";
import "../coffeescript/push_notifications.coffee";
import "../coffeescript/search_groups.coffee";
import "../coffeescript/stories.coffee";
import "../coffeescript/stylings.coffee";
import "../coffeescript/templates.coffee";
import "../coffeescript/tips.coffee";
import "../coffeescript/user_i9forms.coffee";
import "../coffeescript/video_pages.coffee";

// JavaScript modules
import "../new_design/csp_inline_handlers.js";
import "../new_design/default.js";
import "../new_design/materialize.js";
import "../new_design/assign_to_group_pages.js";
import "../new_design/course_tags.js";
import "../new_design/csv_import.js";
import "../new_design/dashboard.js";
import "../new_design/embed_pages.js";
import "../new_design/groups.js";
import "../new_design/knowledge_items_data_import.js";
import "../new_design/likert_scale_pages.js";
import "../new_design/manager-toolkit.js";
import "../new_design/multi_choice_image_pages.js";
import "../new_design/multi_choice_pages.js";
import "../new_design/order_image_pages.js";
import "../new_design/order_video_pages.js";
import "../new_design/privacy_policies.js";
import "../new_design/recipients.js";
import "../new_design/refiner.js";
import "../new_design/right_order_text_pages.js";
import "../new_design/screenings.js";
import "../new_design/signings.js";
import "../new_design/users.js";
import "../new_design/validations.js";
import "../new_design/workflows.js";
import "../new_design/email_branding.js";
import "../new_design/notifications.js";

// Duplication scripts
import "../new_design/duplication/chapter-duplication.js";
import "../new_design/duplication/course-duplication.js";
import "../new_design/duplication/knowledge-item-duplication.js";
import "../new_design/duplication/monitor-duplication-statuses.js";
import "../new_design/duplication/story-duplication.js";

// Reporting scripts
import "../new_design/reporting/custom.js";
import "../new_design/reporting/customer_health_bulk_csv_exports.js";
import "../new_design/reporting/manager_report.js";
import "../new_design/reporting/multi_user.js";
import "../new_design/reporting/quiz-chapter.js";
import "../new_design/reporting/report.js";
import "../new_design/reporting/single_user.js";
import "../new_design/reporting/utility_charts.js";
import "../new_design/reporting/your_year_with_appical_bulk_csv_exports.js";
import "../shared/flash_messages.js";